<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["history"] }}</p>
      </div>
      <p class="content_title">{{ placeName.toUpperCase() }}</p>
      <div class="car" v-for="item in Object.keys(details)" :key="item">
        <div class="model">
          <p>{{ detailsMapping[item] }}</p>
        </div>
        <div class="separator"></div>
        <div class="next">
          <p>
            {{ getValue(details[item]) }}
          </p>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    console.log("/components/History/Details.vue");
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
      return;
    } else {
      this.placeId = this.$store.getters.USER.historySelectedPlaceId;
      this.vehicleId = this.$store.getters.USER.historySelectedVehicleId;
      this.details =
        this.$store.getters.USER.vehicles[
          this.$store.getters.USER.vehicles.findIndex(
            (v) => v.id === this.vehicleId
          )
        ].places[
          this.$store.getters.USER.vehicles[
            this.$store.getters.USER.vehicles.findIndex(
              (v) => v.id === this.vehicleId
            )
          ].places.findIndex((p) => p.id === this.placeId)
        ].details;

      this.placeName =
        this.$store.getters.USER.vehicles[
          this.$store.getters.USER.vehicles.findIndex(
            (v) => v.id === this.vehicleId
          )
        ].places[
          this.$store.getters.USER.vehicles[
            this.$store.getters.USER.vehicles.findIndex(
              (v) => v.id === this.vehicleId
            )
          ].places.findIndex((p) => p.id === this.placeId)
        ].name;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      details: {},
      placeId: null,
      vehicleId: null,
      placeName: "",
      detailsMapping: {
        entrance: this.$store.getters.TRANSLATIONS["entrance"],
        timeIn: this.$store.getters.TRANSLATIONS["time_in"],
        timeOut: this.$store.getters.TRANSLATIONS["time_out"],
        duration: this.$store.getters.TRANSLATIONS["duration"],
        parking: this.$store.getters.TRANSLATIONS["parking"],
        valetCharge: this.$store.getters.TRANSLATIONS["valet_charge"],
        taxes: this.$store.getters.TRANSLATIONS["taxes"],
        tipCharge: this.$store.getters.TRANSLATIONS["tip_charge"],
        totalCharge: this.$store.getters.TRANSLATIONS["total_charge"],
        paymentType: this.$store.getters.TRANSLATIONS["payment_type"]
      },
      isISOdate(str) {
        const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
        return isoRegex.test(str);
      },
      getValue(item) {
        return this.isISOdate(item)
          ? this.moment(String(item)).format("MM/DD/YYYY hh:mm")
          : item;
      },
      back: () => {
        this.$router.push("/historyVehiclePlaces");
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.car {
  display: flex;
  background: transparent;
  padding: 1vw;
  margin: 1vh 0;
}
.car .model {
  width: 50%;
  padding: 1vw;
}
.car .model p {
  float: right;
}
.car .next {
  width: 50%;
  padding: 1vw;
  text-align: left;
}
.model {
  color: rgba(114, 174, 255, 1);
}
.next {
  color: #fbae31;
}
.separator {
  background-color: #fbae31;
  width: 1px;
  margin: 0 2vh;
}
</style>



// WEBPACK FOOTER //
// src/components/History/Details.vue